import axios from "../axios";
import { fetchHseSettings } from "./settings";
import { normalizeHseSetupStatus } from "../../components/dashboard/hse/hseCompanySettingsUtils";

function unwrap(response) {
  return response.data?.data || response.data;
}

function raiseApiError(error) {
  const errors = error?.response?.data?.errors;
  const message = Array.isArray(errors)
    ? errors.join(", ")
    : error?.response?.data?.message || error?.message || "error";
  const next = new Error(message);
  next.response = error?.response;
  throw next;
}

export async function fetchHseSetupStatus() {
  try {
    const response = await axios.get("/hse/setup_status");
    return normalizeHseSetupStatus(unwrap(response));
  } catch (error) {
    if (error?.response?.status === 404) {
      const settings = await fetchHseSettings();
      return normalizeHseSetupStatus(settings);
    }
    raiseApiError(error);
  }
}
